
import Hero from "@/components/Hero";
import Navbar from "@/components/Navbar";
import ProblemStatement from "@/components/ProblemStatement";
import FractionalNursing from "@/components/FractionalNursing";
import Benefits from "@/components/Benefits";
import AudienceSection from "@/components/AudienceSection";
import Testimonials from "@/components/Testimonials";
import CostComparison from "@/components/CostComparison";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <ProblemStatement />
        <FractionalNursing />
        <Benefits />
        <AudienceSection />
        <Testimonials />
        <CostComparison />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
